import { ExpandedLinkElement, ImageElement, LinkElement } from '@all-hands-hq/plex-graphql-schema';
import { Editor, Node, Path, Range } from 'slate';

export type ElementWithSelectionMenu = ImageElement | LinkElement | ExpandedLinkElement;

function hasSelectionMenu(node: Node): boolean {
  const slateNode: ElementWithSelectionMenu = (node as unknown) as ElementWithSelectionMenu;
  return slateNode.type === 'link' || slateNode.type === 'image' || slateNode.type === 'expanded_link';
}

export function aboveWithSelectionMenu({
  editor,
  selection,
}: {
  editor: Editor;
  selection: Range;
}): { node: ElementWithSelectionMenu; path: Path } | null {
  const nodeEntry = Editor.above(editor, {
    at: selection,
    match: hasSelectionMenu,
    mode: 'lowest',
  });
  if (nodeEntry != null) {
    return {
      node: (nodeEntry[0] as unknown) as ElementWithSelectionMenu,
      path: nodeEntry[1],
    };
  } else {
    return null;
  }
}
